import {
    GET_REIMBURSEMENT_LIST_BY_USER,
    GET_LATEST_PA,
    SAVE_REIMBURSEMENT,
    RE_LOADING,
    GET_INFORMATION_LISTS,
    GET_STUDIES_CATEGORY,
    GET_VALIDATION,
    RE_LOADING_CAREERS,
    GET_CAREERS,
    RE_LOADING_VALIDATION,
    ALLOW_NEW_REQUEST,
    ALLOW_REQUEST_TYPE
} from "../actions/EducationalReimbursementActions";


const initialState = {
    summary: [],
    employeeReimbursements: [],
    validation: false,
    informationLists: [],
    studiesCatergory: [],
    universityInstitutes: [],
    levels: [],
    studiesCenters: [],
    languages: [],
    certifications: [],
    techStudiesCenter: [],
    careers: [],
    latestPA: [],
    saveReimbursement: null,
    loading: true,
    loadingCareers: true,
    loadingValidation: true
  };

const EducationalReimbursementReducer = function(state = initialState, action) {
    switch (action.type) {
        case RE_LOADING: {
          return {
            ...state,
            loading: true
          }
        }
        case RE_LOADING_CAREERS: {
          return {
            ...state,
            loadingCareers: true
          }
        }
        case RE_LOADING_VALIDATION: {
          return {
            ...state,
            loadingValidation: true
          }
        }
        case SAVE_REIMBURSEMENT: {
          return {
              ...state,
              saveReimbursement : action.data,
              loading: false
          }
      }
        case GET_REIMBURSEMENT_LIST_BY_USER: {
            return {
                ...state,
                summary : [...action.data.summary],
                employeeReimbursements: [...action.data.employeeReimbursements],
                loading: false
            }
        }
        case  GET_LATEST_PA: {
            return {
              ...state,
              latestPA: action.data,
              loading: false
            }
        }
        case GET_INFORMATION_LISTS: {
          return {
            ...state,
            universityInstitutes: [...action.data.universityInstitutes],
            levels: [...action.data.levels],
            languages: [...action.data.languages],
            certifications: [...action.data.certifications],
            loading: false
          }
        }
        case GET_VALIDATION: {
          return {
            ...state,
            validation: action.data,
            loadingValidation: false
          }
        }
        case GET_CAREERS: {
          return {
            ...state,
            careers: [...action.data],
            loadingCareers: false
          }
        }
      case GET_STUDIES_CATEGORY: {
        return {
          ...state,
          studiesCatergory: [...action.data],
          //loading: false
        }
      }
      case "RESET_ALLOW_REQUEST_TYPE":
      return {
        ...state,
        allowRequestType: null,
        loading: false
      }
      case ALLOW_NEW_REQUEST:
        return {
          ...state,
          allowNewRequest: action.data,
          loading: false
        }
        case ALLOW_REQUEST_TYPE:
        return {
          ...state,
           allowRequestType: action.data,
          loading: false
        }
        default: {
            return state;
          }
        }
}

export default EducationalReimbursementReducer;
